import { useEffect } from 'react';
import { parse, stringify } from 'qs';

/**
 * 페이지 방문 시 또는 새로고침 시 URL의 쿼리 스트링에 고유한 `pageKey`를 추가하는 커스텀 훅입니다.
 * `pageKey`가 이미 존재하는 경우에는 아무 작업도 하지 않습니다.
 * 이 훅은 페이지 트래킹이나 고유한 식별자를 생성하는 데 유용합니다.
 */
export const usePageKeyInitializer = () => {
  useEffect(() => {
    /** 브라우저의 '뒤로가기/앞으로가기'를 통한 페이지 이동인지 확인 (새로고침 시에는 pageKey를 재생성하기 위해 false를 반환) */
    const isBackForward =
      (window.performance.getEntriesByType('navigation') as PerformanceNavigationTiming[])?.[0].type === 'back_forward';

    const queryParams = parse(location.search.replace('?', ''));

    // 뒤로가기/앞으로가기로 이동했고, pageKey가 이미 존재하면 기존 값을 유지 -> 새로고침 시에는 재생성
    if (isBackForward && queryParams.pageKey) {
      return;
    }

    // `pageKey`를 현재 타임스탬프로 설정하고, 쿼리 스트링에 추가합니다.
    const query = { ...queryParams, pageKey: new Date().getTime() };

    // 새로운 쿼리 스트링을 URL에 반영합니다.
    window.history.replaceState(null, '', `?${stringify(query)}`);
  }, []);
};
